"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListboxButton = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var indexOf_1 = __importDefault(require("lodash/indexOf"));
var find_1 = __importDefault(require("lodash/find"));
var flatten_1 = __importDefault(require("lodash/flatten"));
var DropdownMenu = __importStar(require("@radix-ui/react-dropdown-menu"));
var ListboxButton = function (_a) {
    var items = _a.items, selectedItem = _a.selectedItem, className = _a.className, children = _a.children, onSelectItem = _a.onSelectItem, title = _a.title;
    var values = (0, flatten_1.default)(items.map(function (group) { return group.items.map(function (item) { return item; }); }));
    var handleChange = function (value) {
        var currentItem = (0, find_1.default)(values, { value: value });
        var currentItemIndex = (0, indexOf_1.default)(values, currentItem);
        onSelectItem(currentItemIndex);
    };
    return (React.createElement("div", { className: (0, classnames_1.default)('cueplayer-react-listbox') },
        React.createElement(DropdownMenu.Root, null,
            React.createElement(DropdownMenu.Trigger, null, children),
            React.createElement(DropdownMenu.Portal, null,
                React.createElement(DropdownMenu.Content, { loop: true, "data-cueplayer-react-listbox": "", side: "top", className: "cueplayer-react-listbox" }, items.map(function (group) { return (React.createElement(DropdownMenu.RadioGroup, { value: selectedItem.value, key: group.label },
                    React.createElement(DropdownMenu.Label, { className: "cueplayer-react-listbox-label" }, group.label),
                    group.items.map(function (item) { return (React.createElement(DropdownMenu.RadioItem, { onSelect: function () { return handleChange(item.value); }, "aria-label": item.label, value: item.value, key: item.value, textValue: item.value }, item.label)); }))); }))))));
};
exports.ListboxButton = ListboxButton;
